/*
创建者 魏强（2018.01.23）
*/
import fetch from "utils/fetch";
/*
发送post请求
@url 请求地址
@data 数据(这里要注意我已经加了body简化写法)
@return Promise
*/
/*v1版本商城接口post*/
export function post(url, data = {}) {
  return fetch({
    url,
    method: "post",
    data: {
      body: data,
    },
  });
}

/*v2版本商城接口post*/
export function post2(url, data = {}) {
  return fetch({
    url,
    method: "post",
    data: data,
  });
}

/*v2版本商城接口get*/
export function get(url, data = {}) {
  return fetch({
    url,
    method: "get",
    data: data,
  });
}

export function postSettle(url, data, type) {
  return fetch({
    url,
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/json",
      "secretType": type ? type : 1
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/post.js